import React, { useEffect, useState } from "react";
import { TbMessageChatbotFilled } from "react-icons/tb";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import ChatInput from "./ChatInput";
import ChatMessage from "./ChatMessage";
import ChatCloseModal from "./ChatCloseModal";
import { getAllData } from "../utilities/firebase-connection";

const ChatForm = ({ siteTheme, isDay, showChat, setShowChat }) => {
	const [areYouSure, setAreYouSure] = useState(false);
	const [messages, setMessages] = useState([]);
	const [greetingResponses, setGreetingResponses] = useState([]);
	const [aiResponses, setAIResponses] = useState([]);
	const [fallback, setFallback] = useState("");
	const [chatType, setChatType] = useState("ChatBot");

	useEffect(() => {
		const stored = sessionStorage.getItem("chatMessages");
		if (stored) {
			setMessages(JSON.parse(stored));
		}

		(async () => {
			const greetingResponses = await getAllData("ai-greet-response");
			setGreetingResponses(greetingResponses?.[0]?.greetingResponses);
			const response = await getAllData("ai-response");
			setAIResponses(response?.[0]?.chatbotAnswers);
			setFallback(response?.[0]?.fallback);
		})();
	}, []);

	useEffect(() => {
		sessionStorage.setItem("chatMessages", JSON.stringify(messages));
	}, [messages]);

	return (
		<>
			{showChat && (
				<div
					className={`z-40 font-saira hidden sm:flex flex-col fixed sm:h-[600px] sm:bottom-20 sm:right-4 sm:w-[60%] md:w-[45%] lg:w-[40%] xl:w-[30%] 2xl:w-[25%] border-[0.5px] rounded-xl overflow-hidden ease-in duration-300 ${
						chatType === "ChatBot"
							? "bg-[rgba(255,255,255,0.3)]"
							: isDay
							? "bg-[rgba(0,0,0,1)]"
							: "bg-[rgba(0,0,0,0.5)]"
					} backdrop-blur-lg ${siteTheme.borderColor}`}>
					<div
						className={`ease-in duration-300 flex w-full flex-row items-center] justify-between p-3 z-10 ${siteTheme.headingBackground}`}>
						<div className="flex items-center gap-1 text-sm">
							<TbMessageChatbotFilled size={25} />
							<div className="flex items-center gap-2">
								<span
									onClick={() => setChatType("ChatBot")}
									className={`cursor-pointer ${
										chatType === "ChatBot" &&
										"py-[3px] rounded-full px-2 bg-teal text-white"
									}`}>
									ChatBot
								</span>
								<span
									onClick={() => setChatType("ChatAI")}
									className={`cursor-pointer ${
										chatType !== "ChatBot" &&
										"py-[3px] rounded-full px-2 bg-teal text-white"
									}`}>
									ChatAI
								</span>
							</div>
						</div>
						<MdOutlineKeyboardArrowDown
							size={25}
							onClick={() => {
								if (messages?.length > 0) {
									setAreYouSure(true);
								} else {
									setShowChat(false);
								}
							}}
							className="cursor-pointer"
						/>
					</div>
					<ChatMessage messages={messages} chatType={chatType} />
					<ChatInput
						siteTheme={siteTheme}
						isDay={isDay}
						messages={messages}
						fallback={fallback}
						chatType={chatType}
						setMessages={setMessages}
						aiResponses={aiResponses}
						greetingResponses={greetingResponses}
					/>
					{areYouSure && (
						<ChatCloseModal
							chatType={chatType}
							siteTheme={siteTheme}
							setShowChat={setShowChat}
							setAreYouSure={setAreYouSure}
							setMessages={setMessages}
						/>
					)}
				</div>
			)}
		</>
	);
};

export { ChatForm };
export default ChatForm;
